import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const MobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 w-full z-[100] p-4 md:hidden"
        >
          <div className="glass-panel border-brand-cyan/20 bg-brand-dark/80 backdrop-blur-xl rounded-2xl p-3 shadow-[0_-10px_40px_rgba(0,0,0,0.5)] flex items-center gap-3">
            <Link 
              to="/demo" 
              className="flex-1 py-4 px-4 rounded-xl glass-panel text-white text-[10px] font-black uppercase tracking-widest text-center"
            >
              Watch Demo
            </Link>
            <Link 
              to="/book-demo" 
              className="flex-[2] py-4 px-4 rounded-xl bg-gradient-to-r from-brand-blue to-brand-cyan text-white text-[10px] font-black uppercase tracking-widest text-center shadow-[0_0_20px_rgba(34,211,238,0.3)]"
            >
              Book Demo
            </Link>
          </div>
          {/* Safe area spacer for iPhone notch */}
          <div className="h-safe-bottom"></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileCTA;